import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {ContactRoutingModule} from './contact-routing.module';
import {ContactComponent} from './contact/contact.component';
import {NgxDropzoneModule} from 'ngx-dropzone';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgxCaptchaModule} from 'ngx-captcha';
import {MatInputModule} from "@angular/material/input";


@NgModule({
	declarations: [
		ContactComponent
	],
	imports: [
		CommonModule,
		ContactRoutingModule,
		NgxDropzoneModule,
		FormsModule,
		ReactiveFormsModule,
		NgxCaptchaModule,
		MatInputModule
	]
})
export class ContactModule {
}
